// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessageEntry_wrapper__UhCVf","hiddenPopoverArrow":"MessageEntry_hiddenPopoverArrow__aKCDE"};